import { TsuLoading } from '@/common/components';
import { AppLayout } from '@/layouts/AppLayout';
import { gql, useMutation } from '@apollo/client';
import { useEffect } from 'react';
import { IPunchoutWaivenet, IPunchoutWaivenetVars } from '../../PunchoutInterface';

const WAIVENET_ADMIN_PUNCHOUT_MUTATION = gql`
  mutation ($destination: String!, $returnURL: String!) {
    punchoutWaivenetAdmin(input: { destination: $destination, returnURL: $returnURL }) {
      success
      link
    }
  }
`;

export function WaivenetAdmin() {
  const [punchoutWaivenetAdminMutation, { data, loading }] = useMutation<
    IPunchoutWaivenet,
    IPunchoutWaivenetVars
  >(WAIVENET_ADMIN_PUNCHOUT_MUTATION, {
    variables: { destination: 'rgalist', returnURL: 'https://test.com.au' },
  });

  useEffect(() => {
    punchoutWaivenetAdminMutation();
  }, []);

  useEffect(() => {
    const handleMessage = (event: MessageEvent<any>) => {
      if (event.origin === 'https://staging.waivenet.com.au') {
        try {
          console.log('[WaivenetReport] Event data:', event.data);
        } catch (err) {
          console.error(`[WaivenetReport] Error parsing message: ${event.data.toString()}`);
        }
      }
    };
    window.addEventListener('message', handleMessage, false);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <AppLayout title='Waivenet Administration'>
      <TsuLoading loading={loading}>
        <iframe
          id="punchout"
          // @ts-ignore
          src={data?.punchoutWaivenetAdmin.link}
          style={{ width: '100%' }}
          height={1080}
        ></iframe>
      </TsuLoading>
    </AppLayout>
  );
}